(ns ycweb.app.website.dlp.widgets.comparisoncard
  (:require
   [rum.core :as rum]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]))

(rum/defc comparison-card < rum/reactive [{:keys [properties]}]
  (let [{:comparison-card/keys
         [item-1-title item-1-description
          item-2-title item-2-description
          comparison-type show-content? usedaterange
          spacer spacersize]} properties]
    [:<>
     (when show-content?
       [:div.yc-section
        [:div {:class (u/bem :flex-grid-group [:flush])}
         [:div {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content.text-card--medium {:class (u/bem :card [:no-hover])}
           (headings/heading item-1-title {:type :h3 :size :tiny})
           [:div.yc-simple-text
            {:dangerouslySetInnerHTML
             {:__html item-1-description}}]]]
         [:div {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content.text-card--medium.choice-card {:class (u/bem :card [:no-hover]) :data-choice-card comparison-type}
           (headings/heading item-2-title {:type :h3 :size :tiny})
           [:div.yc-simple-text
            {:dangerouslySetInnerHTML
             {:__html item-2-description}}]]]]])
     (when (and spacer usedaterange)
       [:div
        {:class (u/bem :dlp-spacer [(if (= spacersize "medium") :medium :standard)])}])]))
